import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { CommitteeRepository } from '@/store/committee-state/committee-state.repository';
import { ContractingAuthorityRepository } from '@/store/contracting-authority-state/contracting-authority-state.repository';

export interface MembersDataTableProps {
  store: CommitteeRepository | ContractingAuthorityRepository;
  rowActions?: DataTableRowActions;
  createAction?: () => void;
  isConsellierMode?: boolean;
}

export const getMembersDataTableStructure = ({ store, createAction, rowActions, isConsellierMode }: MembersDataTableProps): DynamicDataTable => {
  const userEmailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const userLastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.lastName',
    accessorKey: 'lastName',
    variant: DataTableColumnVariant.TEXT,
  };

  const userFirstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.firstName',
    accessorKey: 'firstName',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.createdAt',
    accessorKey: 'createdAt',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: new Date(value).toLocaleDateString('fr-FR'),
      };
    },
  };

  const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.createdBy',
    accessorKey: 'createdBy',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      return {
        value: value,
      };
    },
  };

  return {
    singular: isConsellierMode ? 'settings.consellier.table.singular' : 'settings.members.table.singular',
    plural: isConsellierMode ? 'settings.consellier.table.plural' : 'settings.members.table.plural',
    columns: [userFirstNameColumn, userLastNameColumn, userEmailColumn, createdAtColumn, createdByColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    target: (row: any) => {
      store.set('memberToDelete', row);
    },
    stripedRows: true,
    createAction,
    rowActions,
    searchableFields: ['username', 'email', 'lastName', 'firstName'],
  };
};
